import React, { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  XAxis,
  YAxis,
} from "recharts";
import { Typography, Grid, Box } from "@mui/material";
import instance from "../../globals/axios";
import { useAlert } from "../Alert";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { SERVER_BASE_ADDRESS } from "../../globals/const";
import axios from "axios";

const NutrientProfile = () => {
  const [data, setData] = useState(null);
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const { access_key } = useParams();
  const isReport = !!access_key;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let response;
        if (isReport) {
          const url = `${SERVER_BASE_ADDRESS}/app-admin/get-nutrient-profile-stats/`;
          response = await axios.get(url, {
            headers: {
              Authorization: `Token ${access_key}`,
            },
          });
        } else {
          response = await instance.get(
            "/app-admin/get-nutrient-profile-stats/"
          );
        }

        if (response?.data?.data) {
          setData(response.data.data);
        } else {
          showAlert("Failed to fetch data", "error");
        }
      } catch (error) {
        console.error("Failed to fetch data", error);
        showAlert("Failed to fetch data", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const COLORS = ["#0088FE", "#FFBB28", "#FF0000"];

  const centeredItemStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <Box style={{ padding: "5px" }}>
      {!isReport && loading ? (
        <Typography variant="h6">{`${t("Loading")}...`}</Typography>
      ) : data ? (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} style={centeredItemStyle} sx={{ mt: 10 }}>
            <Typography variant="subtitle1">
              {t("Average NPK Levels")}
            </Typography>
            <BarChart width={350} height={350} data={data.average_npk}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar
                dataKey="value"
                fill="#8884d8"
                isAnimationActive={!isReport}
              />
            </BarChart>
          </Grid>

          <Grid item xs={12} sm={6} style={centeredItemStyle} sx={{ mt: 10 }}>
            <Typography variant="subtitle1">{t("Nitrogen (N)")}</Typography>
            <PieChart width={350} height={350}>
              <Pie
                data={data.nitrogen_distribution}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={90}
                fill="#8884d8"
                isAnimationActive={!isReport}
              >
                {data.nitrogen_distribution?.map((entry, index) => (
                  <Cell
                    key={`cell-n-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            style={centeredItemStyle}
            sx={{ marginTop: 13 }}
          >
            <Typography variant="subtitle1">{t("Phosphorus (P)")}</Typography>
            <PieChart width={350} height={350}>
              <Pie
                data={data.phosphorus_distribution}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={90}
                fill="#8884d8"
                isAnimationActive={!isReport}
              >
                {data.phosphorus_distribution?.map((entry, index) => (
                  <Cell
                    key={`cell-p-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            style={centeredItemStyle}
            sx={{ marginTop: 13 }}
          >
            <Typography variant="subtitle1">{t("Potassium (K)")}</Typography>
            <PieChart width={350} height={350}>
              <Pie
                data={data.potassium_distribution}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={90}
                fill="#8884d8"
                isAnimationActive={!isReport}
              >
                {data.potassium_distribution?.map((entry, index) => (
                  <Cell
                    key={`cell-k-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </Grid>
        </Grid>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100px",
          }}
        >
          <Typography variant="h6">{t("No data available")}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default NutrientProfile;
